import { GetAllGenericPropsQuery } from "@graphql";
import { createContext, useContext } from "react";

export const StrapiPreloadedPropsContext = createContext<GetAllGenericPropsQuery | undefined>(
  undefined,
);

export const useStrapiPreloadedProps = () => {
  const context = useContext(StrapiPreloadedPropsContext);

  if (!context) {
    return {};
  }

  return context;
};
